<template>
  <div>
    <b-card :title="$t('warehouse.warehouse-transfer')">
      <b-card-text>
        <b-row>
          <b-col class="mt-1" lg="12">
            <b-form-group :label="$t('common.date')" label-for="Date">
              <datepicker
                v-model="date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD H:i"
              ></datepicker>
            </b-form-group>
          </b-col>
          <b-col class="mt-1" lg="12">
            <AutoComplete
              :label="$t('warehouse.to-warehouse')"
              :placeholder="`${$t('common.select')} ${$t(
                'warehouse.one-warehouse'
              )}`"
              v-model="warehouse_id"
              param-query="search"
              :serializer="(val) => val.id"
              endpoint="warehouse"
              text-title="name"
              :otherQuery="`filter[type]=hospital`"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <b-card>
      <ScanBarcode @barcode="addToItemsList($event)" />
    </b-card>
    <b-card :title="$t('warehouse.item')" v-if="showTables">
      <b-table
        :items="items"
        responsive
        :fields="itemsCloumns"
        primary-key="id"
        show-empty
        empty-text="No matching results found"
        class="position-relative"
        v-if="!loading"
      >
        <template #cell(expiry_date)="data">
          <b-badge pill :variant="getBadgeVariant(data.item.expiry_date)">{{
            data.item.expiry_date
          }}</b-badge>
        </template>
        <template #cell(changeable-quantity)="data">
          <b-form-input
            type="number"
            id="Quantity"
            v-model="data.item.editableQuantities"
            :placeholder="$t('warehouse.quantity')"
          />
        </template>
        <!-- <template #cell(unit_price)="data">
          <b-form-input
            type="number"
            id="Price"
            v-model="data.item.unit_price"
            :placeholder="$t('warehouse.price')"
          />
        </template> -->
        <template #cell(actions)="data">
          <!-- <b-button
            class="mt-2"
            ref="myButton"
            pill
            size="sm"
            variant="outline-primary"
            @click="addToStockOuts(data.item)"
          >
            {{ $t("common.add") }}
          </b-button> -->
          <b-button size="sm" variant="danger" @click="removeItem(data.item)"
            >X</b-button
          >
        </template>
      </b-table>
      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner :label="$t('common.loading')" />
          </div>
        </div>
      </template>
      <div class="d-flex justify-content-end">
        <b-button
          :disabled="items.length === 0"
          class="mt-2"
          ref="myButton"
          variant="primary"
          @click="submitItem"
        >
          {{ $t("common.submit") }}
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BCardText,
  BBadge,
  BFormTextarea,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import Datepicker from "vuejs-datepicker";
const CategoryModal = () => import("@/components/warehouse/CategoryModal.vue");
const ScanBarcode = () => import("@/views/warehouse/ScanBarcode.vue");

export default {
  components: {
    BCard,
    BFormTextarea,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BLink,
    AutoComplete,
    Datepicker,
    BBadge,
    BCardText,
    CategoryModal,
    ScanBarcode,
  },
  data() {
    return {
      categoryFilter: {
        name: "",
        id: "",
      },
      editableQuantities: {},

      isBarCodeStep: false,
      showTables: false,
      loading: true,
      items: [],
      ItemId: null,
      employee_id: "",
      patient_card_id: this.$route.params.patient_card_id,
      date: this.formatExpDate(Date.now()),
      description: "",
      stockoutForm: {
        item_id: "",
        warehouse_id: "",
        batch_no: "",
        balance_id: "",
        expiry_date: "",
        quantity: "",
        unit_price: "",
      },
      itemsCloumns: [
        { key: "item.name", label: this.$t("common.name"), sortable: true },
        {
          key: "category.name",
          label: this.$t("warehouse.one-category"),
          sortable: true,
        },
        {
          key: "warehouse.name",
          label: this.$t("warehouse.one-warehouse"),
          sortable: true,
        },
        {
          key: "batch_no",
          label: this.$t("warehouse.batch-no"),
          sortable: true,
        },
        {
          key: "expiry_date",
          label: this.$t("warehouse.exp-date"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("warehouse.quantity"),
          sortable: true,
        },
        {
          key: "changeable-quantity",
          label: this.$t("warehouse.change-quantity"),
          sortable: true,
        },
        {
          key: "purchase_price",
          label: this.$t("warehouse.price"),
          sortable: true,
        },
        {
          key: "sell_price",
          label: this.$t("warehouse.price"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      tableColumns: [
        { key: "item_id.", label: this.$t("common.name"), sortable: true },
        {
          key: "warehouse_id",
          label: this.$t("warehouse.one-warehouse"),
          sortable: true,
        },
        {
          key: "batch_no",
          label: this.$t("warehouse.batch-no"),
          sortable: true,
        },
        {
          key: "quantity",
          label: this.$t("warehouse.quantity"),
          sortable: true,
        },
        {
          key: "unit_price",
          label: this.$t("warehouse.price"),
          sortable: true,
        },
        {
          key: "expiry_date",
          label: this.$t("warehouse.exp-date"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      stockouts: [],
      params: {
        form: {},
        path: "",
      },
      warehouse_id: null,
    };
  },

  methods: {
    getBadgeVariant(date) {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();

      const itemDate = new Date(date);
      const itemMonth = itemDate.getMonth();
      const itemYear = itemDate.getFullYear();

      return itemMonth === currentMonth && itemYear === currentYear
        ? "danger"
        : "success";
    },
    async addToItemsList(barcode) {
      this.loading = true;

      let url = `/balance?filter[barcode]=${parseInt(barcode)}&filter[type]=${
        this.$route.name.includes("pharmacy") ? "pharmacy" : "hospital"
      }&sort=expiry_date&include=category,item,warehouse`;

      await this.getList(url);

      if (this.all_data.data.length > 0) {
        this.all_data.data.forEach((item) => {
          // Check if item already exists in the array
          const existingItem = this.items.find(
            (existing) => existing.id === item.id
          );

          if (existingItem) {
            // If item exists, increase its quantity by 1
            if (
              parseInt(existingItem.quantity) >
              parseInt(existingItem.editableQuantities)
            ) {
              existingItem.editableQuantities =
                parseInt(existingItem.editableQuantities) + 1;
            } else {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Item (${existingItem.item.name}) quantity : ${existingItem.quantity} is less than editable quantity : ${existingItem.editableQuantities}`,
                  variant: "danger",
                },
              });
            }
          } else {
            // If item does not exist, initialize quantity to 1 and add to list
            item.editableQuantities = 1;
            this.items.push(item);
          }
          // // Ensure editableQuantities reflects the updated quantity
          // this.$set(
          //   this.editableQuantities,
          //   item.id,
          //   existingItem ? existingItem.quantity : item.quantity
          // );
        });

        this.isBarCodeStep = false;
      } else {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `${this.$t("common.item-not-found")}`,
            variant: "danger",
            timeout: 10000,
          },
        });
      }

      this.showTables = true;
      this.loading = false;
    },
    removeItem(item) {
      this.items = this.items.filter((stokout) => stokout !== item);
    },
    showScanner() {
      (this.isBarCodeStep = true), (this.showTables = false);
    },
    formatExpDate(expDate) {
      // Create a new Date object from the selected date
      const date = new Date(expDate);

      // Format the date as "yyyy-MM-dd"
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1); // getMonth() is zero-based
      let day = "" + date.getDate();

      // Pad single digit months and days with a leading zero
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },

    submitItem() {
      this.items.forEach((item) => {
        if (parseInt(item.quantity) < parseInt(item.editableQuantities)) {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: `Item (${item.item.name}) quantity : ${item.quantity} is less than editable quantity : ${item.editableQuantities}`,
              variant: "danger",
            },
          });
          return 0;
        }
      });

      if (this.warehouse_id == null) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: `Warehouse is not selected`,
            variant: "danger",
          },
        });
        return 0;
      }

      this.date = this.formatExpDate(this.date);
      console.log(this.items);
      this.stockouts = this.items.map((stock) => ({
        quantity: parseInt(stock.editableQuantities),
        price: parseInt(stock.purchase_price),
        balance_id: stock.id,
        warehouse_id: this.warehouse_id,
      }));

      (this.params.form = {
        date: this.date,
        stockouts: this.stockouts,
      }),
        (this.params.path = `/stockout/internalWarehouseTransfer`),
        this.$store
          .dispatch("create", this.params)
          .then((response) => {
            this.$router.push({
              name: "balance",
            });

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Created",
                variant: "success",
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              this.stockouts = [];

              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
